import React from 'react';
import { Info } from 'lucide-react';

interface ImageFormatHelperProps {
  purpose: 'hero' | 'gallery' | 'general';
  className?: string;
}

export const ImageFormatHelper: React.FC<ImageFormatHelperProps> = ({ 
  purpose, 
  className = ""
}) => {
  const getRecommendations = () => {
    switch (purpose) {
      case 'hero':
        return {
          dimensions: '1920x1080px minimum',
          format: 'JPEG or WebP',
          size: 'Under 500KB after compression',
          tips: [
            'Use landscape orientation (16:9 ratio)',
            'Ensure good contrast for text overlay',
            'Avoid busy patterns in text areas'
          ]
        };
      case 'gallery':
        return {
          dimensions: '1200x800px minimum',
          format: 'JPEG or WebP',
          size: 'Under 300KB after compression',
          tips: [
            'Consistent aspect ratios look better',
            'Show different angles and features',
            'Natural lighting photographs well'
          ]
        };
      default:
        return {
          dimensions: '800x600px minimum',
          format: 'JPEG, PNG, or WebP',
          size: 'Under 200KB',
          tips: ['Clear, high-quality images', 'Proper lighting']
        };
    }
  };

  const recs = getRecommendations();

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm ${className}`}>
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-blue-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1 space-y-2">
          <p className="font-medium text-blue-900">Image Requirements:</p>
          <ul className="space-y-1 text-blue-800">
            <li>• Dimensions: {recs.dimensions}</li>
            <li>• Format: {recs.format}</li>
            <li>• File size: {recs.size}</li>
          </ul>
          <div className="mt-3">
            <p className="font-medium text-blue-900 mb-1">Pro tips:</p>
            <ul className="space-y-1 text-blue-700">
              {recs.tips.map((tip, i) => (
                <li key={i}>• {tip}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}; 